import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowBottom } from '../../../ui/icons';
import styled from 'styled-components';
import { FaFacebook, FaInstagram, FaTelegram, FaWhatsapp, FaYoutube } from "react-icons/fa";

const WrapperArrow = styled.div`
@media(max-width: 1023px) {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap-reverse;
}
`;

const Show = styled.div`
@media(max-width: 1023px) {
    display: block !important;
}
`;

const Hidden = styled.div`
@media(max-width:1023px) {
    display: none;
}
`;

const FormChange = styled.form`
@media(max-width: 1023px) {
    width: 90% !important;
    margin: 0 auto !important;
}
`;

const Six = () => {
    const { t } = useTranslation();
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    const handleNameChange = (e) => {
        setName(e.target.value);
    };

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    };

    const handleMessageChange = (e) => {
        setMessage(e.target.value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
    };

    const styles = {
        img: {
            padding: "40px 0",
            background: "rgba(10, 31, 68, 1)",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "cover"
        },
        hidden: {
            display: 'none'
        }
    };

    return (
        <section style={styles.img}>
            <h2 className="text-[32px] text-center text-white pt-3 sm:text-[44px] font-bold">{t('contact_form.contact_us')}</h2>
            <div className="flex flex-col lg:flex-row bg-cover bg-center relative">
                <div className="flex-1 bg-[#0A1F44] text-white flex flex-col gap-5">
                    <FormChange onSubmit={handleSubmit} className='flex flex-col lg:p-12 py-5'>
                        <label htmlFor="">{t('contact_form.your_name')}</label>
                        <input
                            className="border-b-2 border-[#efebeb] bg-transparent text-white p-2 mb-5 text-sm outline-none"
                            type="text"
                            placeholder={t('contact_form.enter_your_name')}
                            value={name}
                            onChange={handleNameChange}
                        />
                        <label htmlFor="">{t('contact_form.your_email')}</label>
                        <input
                            className="border-b-2 border-[#efebeb] bg-transparent text-white p-2 mb-5 text-sm outline-none"
                            type="email"
                            placeholder={t('contact_form.enter_your_email')}
                            value={email}
                            onChange={handleEmailChange}
                        />
                        <label htmlFor="">{t('contact_form.your_message')}</label>
                        <input
                            className="border-b-2 border-[#efebeb] bg-transparent text-white p-2 mb-5 text-sm outline-none"
                            type="text-area"
                            placeholder={t('contact_form.write_here')}
                            value={message}
                            onChange={handleMessageChange}
                        />
                        <button
                            type="submit"
                            className="bg-[#8C1C1C] text-white py-[13.5px] px-5 cursor-pointer text-sm b-1 rounded-xl text-[16px]"
                        >
                            {t('contact_form.submit')}
                        </button>
                    </FormChange>
                </div>
                <div className="flex-1 py-5 p-8 lg:p-12 bg-[#0A1F44] justify-between text-white flex flex-col gap-5">
                    {/* <div className="flex flex-col gap-4">
                        <p className="text-[20px] flex flex-col font-bold"><span className='font-light text-[15px]'>{t('contact_form.phone_number')}</span> + 374 93 833238</p>
                    </div> */}
                    <div className="flex flex-col gap-4">
                        <p className="text-[20px] flex flex-col font-bold"><span className='font-light text-[15px]'>{t('contact_form.email')}</span> info@oaacourses.com</p>
                    </div>
                    <div>
                        <p className="text-[20px] flex flex-col font-bold"><span className='font-light text-[15px]'>{t('contact_form.social_media')}</span></p>
                        <div className="space-y-2 flex flex-wrap items-end gap-5">
                            {[
                                { icon: <FaWhatsapp />, name: t('contact_form.whatsapp') },
                                { icon: <FaTelegram />, name: t('contact_form.telegram') },
                                { icon: <FaInstagram />, name: t('contact_form.instagram') },
                                { icon: <FaFacebook />, name: t('contact_form.facebook') },
                                { icon: <FaYoutube />, name: t('contact_form.youtube') }
                            ].map((social, index) => (
                                <div key={index}
                                     className="flex items-start justify-center gap-2 text-sm hover:text-[#c6a982] transition cursor-pointer">
                                    <span className="text-2xl">{social.icon}</span>
                                    <span>{social.name}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Six;